<nav class="sidebar" aria-label="Main menu">
	<div class="brand" title="+Business · Plus Admin">
		<span class="brand-mark" aria-hidden="true">+</span>
	</div>

	<div class="rail">
		@if (home(); as h) {
			<a class="tile"
				[routerLink]="h.path"
				routerLinkActive="current"
				[routerLinkActiveOptions]="{ exact: true }"
				(click)="close()">
				<svg class="tile-icon" viewBox="0 0 24 24" aria-hidden="true"><path [attr.d]="h.icon" /></svg>
				<span class="tile-label">{{ h.label }}</span>
			</a>
		}

		@for (s of sections(); track s.id) {
			<button type="button" class="tile"
				[attr.data-section]="s.id"
				[class.open]="open()?.id === s.id"
				[class.current]="currentId() === s.id"
				[attr.aria-expanded]="open()?.id === s.id"
				aria-controls="sidebar-flyout"
				(click)="toggleSection(s.id)">
				<svg class="tile-icon" viewBox="0 0 24 24" aria-hidden="true"><path [attr.d]="s.icon" /></svg>
				<span class="tile-label">{{ s.label }}</span>
				@if (waiting(s); as n) {
					<span class="tile-badge" [attr.aria-label]="n + ' waiting'">{{ n }}</span>
				}
			</button>
		}
	</div>

	<div class="sidebar-footer">
		@if (displayName()) {
			<div class="who" [title]="displayName()" aria-hidden="true">{{ initials() }}</div>
		}
		<button type="button" class="sign-out" (click)="onLogout()"
			[title]="displayName() ? 'Sign out ' + displayName() : 'Sign out'"
			aria-label="Sign out">
			<span aria-hidden="true">⏻</span>
		</button>
	</div>
</nav>

<!-- Second level: the open section's destinations, over the page, or docked beside the rail when pinned. -->
@if (open(); as s) {
	@if (!docked()) {
		<button type="button" class="scrim" aria-label="Close menu" (click)="close()"></button>
	}
	<aside class="flyout" id="sidebar-flyout" tabindex="-1" [class.docked]="docked()" [attr.aria-label]="s.label + ' menu'">
		<div class="flyout-head">
			<div class="flyout-title">
				<h2>{{ s.label }}</h2>
				<div class="flyout-count">{{ s.links.length }} {{ s.links.length === 1 ? 'destination' : 'destinations' }}</div>
			</div>
			<div class="flyout-tools">
				<button type="button" class="flyout-tool pin" (click)="togglePin()"
					[attr.aria-pressed]="pinned()"
					[attr.aria-label]="pinned() ? 'Unpin menu' : 'Keep menu open'"
					[title]="(pinned() ? 'Unpin menu' : 'Keep menu open') + ' (Ctrl+B)'">
					<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 17v5M8 3h8l-1 7 3 3H6l3-3z" /></svg>
				</button>
				@if (!docked()) {
					<button type="button" class="flyout-tool" (click)="close()" aria-label="Close menu" title="Close (Esc)">
						<span aria-hidden="true">×</span>
					</button>
				}
			</div>
		</div>

		<div class="flyout-list">
			@for (l of s.links; track l.path) {
				<a class="nav-link"
					[routerLink]="l.path"
					routerLinkActive="active"
					[routerLinkActiveOptions]="{ exact: !!l.exact }"
					(click)="close()">
					<span class="nav-icon" aria-hidden="true">{{ l.icon }}</span>
					<span class="nav-label">{{ l.label }}</span>
					@if (badgeFor(l); as n) {
						<span class="nav-badge" [attr.aria-label]="n + ' waiting'">{{ n }}</span>
					}
				</a>
			}
		</div>

		@if (displayName()) {
			<div class="flyout-foot" [title]="displayName()">{{ displayName() }}</div>
		}
	</aside>
}
